import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=4bc0f2b0&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=4bc0f2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0f2b0",
  null
  
)

export default component.exports